import { saglikTakipli } from "../domain/students.js";
import { ATT, EVENT_TYPE, card, emptyNote, sectionTitle } from "../components/ui.js";
import { B, cls, staffOf, stu } from "../domain/context.js";
import { avatar, staffAvatar } from "../lib/avatar.js";
import { esc, money } from "../lib/fmt.js";
import { faturaDurumu, faturaTutari, payOf } from "../domain/invoices.js";
import { state } from "../state.js";
import { viewSiniflar } from "./siniflar.js";

// ---------- SINIF DETAYI ----------
export function viewSinifDetay() {
  const t = B();
  const c = cls(state.classId);
  if (!c) return viewSiniflar();

  const kids = t.students.filter(s => s.classId === c.id);
  const teacher = staffOf(c.teacherId);
  const helpers = t.staff.filter(p => p.classId === c.id && p.id !== c.teacherId);
  const pct = Math.round(kids.length / c.capacity * 100);
  const bos = c.capacity - kids.length;

  const att = k => kids.filter(s => t.attendance[s.id]?.status === k);
  const gelenler = att("geldi");
  const raporlu = kids.filter(s => t.dailyReports.some(r => r.studentId === s.id));
  const raporsuz = gelenler.filter(s => !t.dailyReports.some(r => r.studentId === s.id));
  const saglik = saglikTakipli(kids);
  const tahakkuk = kids.reduce((a, s) => { const inv = payOf(s.id); return a + (inv ? faturaTutari(s, inv) : 0); }, 0);
  const bekleyen = kids.filter(s => { const inv = payOf(s.id); return inv && faturaDurumu(s, inv) !== "odendi"; });

  const today = new Date().toISOString().slice(0, 10);
  const etkinlikler = t.events.filter(e =>
    e.date >= today && (e.scope.includes(c.name) || /tüm sınıflar|kurum|tüm veliler/i.test(e.scope)));

  return `
  <a href="#/siniflar" class="inline-flex items-center gap-1.5 text-sm font-semibold text-inksoft hover:text-ink mb-3">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
    Tüm sınıflar
  </a>

  ${card(`
    <div class="h-2.5 rounded-t-2xl" style="background:${c.color}"></div>
    <div class="p-5">
      <div class="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h2 class="font-display font-extrabold text-2xl">${esc(c.name)}</h2>
          <div class="text-sm text-inksoft mt-0.5">${c.age} · ${esc(c.room)} · ${esc(c.ratio)}</div>
        </div>
        <div class="flex gap-2 flex-wrap">
          <div class="rounded-xl px-4 py-2 text-center" style="background:${c.color}1A">
            <div class="font-display font-extrabold text-xl" style="color:${c.color}">${kids.length}/${c.capacity}</div>
            <div class="text-[10px] font-bold uppercase" style="color:${c.color}">Doluluk</div>
          </div>
          <div class="rounded-xl bg-paper px-4 py-2 text-center">
            <div class="font-display font-extrabold text-xl">${bos}</div>
            <div class="text-[10px] font-bold uppercase text-inksoft">Boş kontenjan</div>
          </div>
        </div>
      </div>
      <div class="h-2 rounded-full bg-paper overflow-hidden mt-4">
        <div class="h-full rounded-full" style="width:${pct}%;background:${c.color}"></div>
      </div>
    </div>`, "overflow-hidden mb-4")}

  <div class="grid gap-4 lg:grid-cols-3">
    <div class="min-w-0 lg:col-span-2 space-y-4">
      ${card(`
        <div class="p-5">
          ${sectionTitle("Bugünkü Yoklama", `
            <span class="flex gap-1.5">
              ${Object.entries(ATT).map(([k, v]) => `<span class="text-[11px] font-bold rounded-full px-2.5 py-0.5 ${v.chip}">${v.label} ${att(k).length}</span>`).join("")}
            </span>`)}
          <div class="grid gap-2 sm:grid-cols-2">
            ${kids.map(s => {
              const a = t.attendance[s.id];
              const m = ATT[a.status];
              return `<button data-student="${s.id}" class="min-w-0 flex items-center gap-3 rounded-xl border border-line bg-paper/50 hover:bg-paper px-3 py-2.5 text-left transition">
                ${avatar(s)}
                <span class="min-w-0 flex-1">
                  <span class="block text-sm font-semibold truncate">${esc(s.name)}</span>
                  <span class="block text-[11px] text-inksoft truncate">
                    ${a.status === "geldi" ? `Giriş ${a.in}${a.out ? ` · Çıkış ${a.out}` : ""}` : a.reason ? esc(a.reason) : "—"}
                  </span>
                </span>
                <span class="text-[11px] font-bold rounded-full px-2.5 py-1 ${m.chip}">${m.label}</span>
              </button>`;
            }).join("") || emptyNote("Bu sınıfta kayıtlı öğrenci yok.")}
          </div>
        </div>`)}

      ${card(`
        <div class="p-5">
          ${sectionTitle("Günlük Rapor Durumu", `<span class="text-[11px] text-inksoft">${raporlu.length}/${gelenler.length} rapor girildi</span>`)}
          ${raporsuz.length
            ? `<div class="rounded-xl bg-sun-soft p-3 mb-3">
                 <div class="text-[11px] font-bold text-[#B07E14] uppercase">Rapor bekleyen ${raporsuz.length} çocuk</div>
                 <div class="flex flex-wrap gap-1.5 mt-2">
                   ${raporsuz.map(s => `<button data-student="${s.id}" class="text-xs font-semibold rounded-full bg-white px-2.5 py-1">${esc(s.name)}</button>`).join("")}
                 </div>
               </div>`
            : `<div class="rounded-xl bg-teal-soft p-3 mb-3 text-sm text-teal font-semibold">Gelen tüm çocukların raporu girildi ✅</div>`}
          <div class="space-y-2">
            ${t.dailyReports.filter(r => stu(r.studentId)?.classId === c.id).map(r => {
              const s = stu(r.studentId);
              return `<button data-student="${s.id}" class="w-full flex items-start gap-3 rounded-xl border border-line px-3 py-2.5 text-left hover:bg-paper/60">
                ${avatar(s, "w-8 h-8 text-[10px]")}
                <span class="min-w-0 flex-1">
                  <span class="flex items-center gap-2">
                    <span class="text-sm font-semibold">${esc(s.name)}</span>
                    <span class="text-[10px] font-bold rounded-full bg-grape-soft text-grape px-2 py-0.5">${esc(r.mood)}</span>
                  </span>
                  <span class="block text-[11px] text-inksoft mt-0.5">🥐 ${esc(r.meals.kahvalti)} · 🍲 ${esc(r.meals.ogle)} · 😴 ${esc(r.sleep)}</span>
                  ${r.note ? `<span class="block text-[11px] mt-1">📌 ${esc(r.note)}</span>` : ""}
                </span>
              </button>`;
            }).join("") || emptyNote("Henüz rapor girilmemiş.")}
          </div>
        </div>`)}
    </div>

    <div class="min-w-0 space-y-4">
      ${card(`
        <div class="p-5">
          ${sectionTitle("Kadro")}
          <div class="space-y-3">
            ${[teacher, ...helpers].filter(Boolean).map(p => `
              <button data-staff="${p.id}" class="w-full flex items-center gap-3 text-left rounded-lg hover:bg-paper/70 -mx-2 px-2 py-1">
                ${staffAvatar(p)}
                <span class="min-w-0 flex-1">
                  <span class="block text-sm font-semibold truncate">${esc(p.name)}</span>
                  <span class="block text-[11px] text-inksoft truncate">${esc(p.role)} · ${esc(p.phone)}</span>
                </span>
                ${p.status === "izinli" ? `<span class="text-[10px] font-bold rounded-full bg-sun-soft text-[#B07E14] px-2 py-0.5 shrink-0">İzinli</span>` : ""}
              </button>`).join("")}
          </div>
        </div>`)}

      ${card(`
        <div class="p-5">
          ${sectionTitle("Sağlık & Alerji", `<span class="text-[11px] rounded-full bg-coral-soft text-coral font-bold px-2 py-0.5">${saglik.length}</span>`)}
          <div class="space-y-2">
            ${saglik.map(s => `
              <button data-student="${s.id}" class="w-full text-left rounded-xl bg-coral-soft/60 px-3 py-2 hover:bg-coral-soft">
                <span class="block text-sm font-semibold">${esc(s.name)}</span>
                <span class="block text-[11px] text-inksoft">${s.allergies.length ? "Alerji: " + s.allergies.join(", ") : ""}${s.allergies.length && s.note ? " · " : ""}${esc(s.note)}</span>
              </button>`).join("") || emptyNote("Bu sınıfta uyarı yok 🎉")}
          </div>
        </div>`)}

      ${card(`
        <div class="p-5">
          ${sectionTitle("Ücret & Tahsilat")}
          <dl class="space-y-2 text-sm">
            <div class="flex justify-between"><dt class="text-inksoft">Tam gün</dt><dd class="font-semibold">${money(c.tuition)}</dd></div>
            <div class="flex justify-between"><dt class="text-inksoft">Yarım gün</dt><dd class="font-semibold">${money(c.tuitionHalf)}</dd></div>
            <div class="flex justify-between"><dt class="text-inksoft">Servis dahil</dt><dd>${money(c.tuition + t.serviceFee)}</dd></div>
          </dl>
          <div class="mt-3 pt-3 border-t border-line/70">
            <div class="flex justify-between text-sm"><span class="text-inksoft">Aylık tahakkuk</span><span class="font-display font-bold">${money(tahakkuk)}</span></div>
            ${bekleyen.length
              ? `<button data-goto="odemeler" class="text-[11px] font-semibold text-coral hover:underline mt-1">${bekleyen.length} öğrencide tahsilat bekliyor →</button>`
              : `<div class="text-[11px] text-teal font-semibold mt-1">Tüm ödemeler tahsil edildi ✅</div>`}
          </div>
        </div>`)}

      ${card(`
        <div class="p-5">
          ${sectionTitle("Yaklaşan Etkinlikler")}
          <div class="space-y-2">
            ${etkinlikler.map(e => {
              const et = EVENT_TYPE[e.type];
              const d = new Date(e.date + "T00:00:00");
              return `<div class="flex items-center gap-3">
                <span class="w-10 shrink-0 text-center rounded-lg py-1" style="background:${et.color}1A">
                  <span class="block font-display font-bold text-sm leading-none" style="color:${et.color}">${d.getDate()}</span>
                  <span class="block text-[9px] font-bold uppercase" style="color:${et.color}">${d.toLocaleDateString("tr-TR", { month: "short" })}</span>
                </span>
                <span class="min-w-0 flex-1">
                  <span class="block text-sm font-semibold truncate">${esc(e.title)}</span>
                  <span class="block text-[11px] text-inksoft truncate">${esc(e.scope)}</span>
                </span>
              </div>`;
            }).join("") || emptyNote("Planlanmış etkinlik yok.")}
          </div>
        </div>`)}
    </div>
  </div>`;
}

